var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isMobile ? 'mt-2' : 'd-flex justify-end mt-1'},[(!_vm.isMobile)?_c('h1',{staticClass:"app-private-title mt-1 mr-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{class:_vm.isMobile
        ? 'c-fill-form__input-mobile'
        : 'c-fill-form__input-pc'},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }